import { For, type JSX } from "solid-js";
import "../home.css";

/**
 * A row of items that scrolls on a loop and pauses under the pointer or focus.
 * Duration scales with the item count so every row moves at about the same
 * pace; `reverse` runs it the other way, so stacked rows don't march in step.
 */
export const Marquee = <T,>(props: {
  each: T[];
  label: string;
  reverse?: boolean;
  children: (item: T) => JSX.Element;
}) => (
  <div
    class="mq overflow-hidden mask-[linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]"
    classList={{ "mq-reverse": props.reverse }}
    style={{ "--mq-duration": `${Math.max(24, props.each.length * 2.8)}s` }}
  >
    <div class="mq-track flex w-max py-2">
      <ul aria-label={props.label} class="flex shrink-0 items-center gap-x-3 pe-3">
        <For each={props.each}>{(item) => <li class="shrink-0">{props.children(item)}</li>}</For>
      </ul>
      <ul aria-hidden="true" inert class="mq-dup flex shrink-0 items-center gap-x-3 pe-3">
        <For each={props.each}>{(item) => <li class="shrink-0">{props.children(item)}</li>}</For>
      </ul>
    </div>
  </div>
);
